import ToastService from 'primevue/toastservice'

let toastService

/**
 * Connects the app-level PrimeVue Toast service to this small wrapper.
 * This is called once during app bootstrap; components only need to import
 * `toast` and call `toast(content, severity)`.
 */
export function configureToast(service) {
  toastService = service
}

export function toast(content, severity = 'info') {
  if (!toastService) return

  toastService.add({
    severity,
    detail: content,
    life: 3000,
  })
}

export { ToastService }
